<template>
    <div>
        <div class="row">
            <div class="col-3">
                <v-alert text class="mb-5">
                    Une <strong>boite d'envoi</strong> est un compte e-mail utilisé par Uska pour envoyer vos
                    e-mails.<br />
                    Vous pouvez définir un <strong>Nom</strong> d'expéditeur pour chaque boite d'envoi.<br />
                    Pour pouvoir envoyer des e-mails à partir de vos boites d'envoi, vous devez les
                    <strong>valider</strong>.
                </v-alert>

                <v-alert type="info" text class="mb-5">
                    Pour valider une boite d'envoi, il suffit de cliquer sur le lien présent dans l'e-mail de validation
                    reçu.
                </v-alert>
            </div>
            <div class="col">
                <v-card :class="singleMod === undefined ? 'p-0 elevation-0' : 'p-4'">
                    <div class="d-flex mb-5 gap-15">
                        <v-btn outlined class="custom-button-primary" @click="selectMemberDialog = true">
                            <v-icon left>add</v-icon> Ajouter une boîte d'envoi
                        </v-btn>
                        <v-btn outlined class="custom-button-primary" @click="checkEmailsValidation">
                            <v-icon id="updateBtn" left>autorenew</v-icon> Actualiser
                        </v-btn>
                    </div>

                    <div v-if="account.senders.length">
                        <v-data-table :headers="headers" :items="account.senders" :loading="$global.loading"
                            class="border" :footer-props="{
                                itemsPerPageAllText: 'Toutes',
                                itemsPerPageText: 'Tags par page',
                                itemsPerPageOptions: [10, 20, 50, 100]
                            }">
                            <template v-slot:item.name="{ item }">
                                <a @click="prepareUpdate(item)">
                                    {{ item.name }}
                                </a>
                            </template>
                            <template v-slot:item.state_label="{ item }">
                                <div class="d-flex gap-10">

                                    <!-- <div :class="item.delivery === 'WAITING' ? 'bg-warning' : 'bg-success'"
                                        class="mt-auto mb-auto badge text-white">
                                        {{ item.state_label }}
                                    </div> -->

                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <div v-on="on"
                                                :class="item.delivery === 'WAITING' ? 'bg-warning' : 'bg-success'"
                                                class="mt-auto mb-auto badge text-white">
                                                {{ item.state_label }}
                                            </div>
                                        </template>
                                        <span v-if="item.delivery === 'WAITING'">E-mail en attente de
                                            vérification</span>
                                        <span v-else>E-mail déjà validé</span>
                                    </v-tooltip>

                                    <v-tooltip bottom v-if="item.delivery === 'WAITING'">
                                        <template v-slot:activator="{ on }">
                                            <v-btn v-on="on" small icon class="custom-button-primary"
                                                @click="sendEmailVerif(item)">
                                                <v-icon>send</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Renvoyer un e-mail de vérification</span>
                                    </v-tooltip>
                                </div>
                            </template>
                            <template v-slot:item.actions="{ item }">
                                <v-btn small icon class="custom-button-error" @click="deleteSender(item)">
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                    </div>

                    <div v-else class="text-center">
                        <small>Aucune boîte d'envoi n'a été configurée pour le moment</small>
                    </div>
                </v-card>
            </div>
        </div>

        <div class="text-right mb-3 mt-5" v-if="singleMod === undefined">
            <v-btn class="default-button mt-3" @click="goNextStep">Passer à l'étape suivante</v-btn>
        </div>

        <v-dialog v-model="selectMemberDialog" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">Ajouter une boîte d'envoi</span>
                </v-card-title>
                <v-card-text>
                    <v-combobox outlined label="Email" :items="availableSenders" v-model="selectedUser" item-text="email"
                        return-object>
                    </v-combobox>

                    <v-text-field label="Nom" outlined v-model="senderName">

                        <v-tooltip slot="append" bottom>
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on">help</v-icon>
                            </template>
                            <span>Nom d'expéditeur utilisé pour l'envoi des e-mails</span>
                        </v-tooltip>

                    </v-text-field>

                    <div class="d-flex justify-content-end gap-10">
                        <v-btn @click="selectMemberDialog = false">Annuler</v-btn>
                        <v-btn class="default-button custom-button-primary" @click="selectSender"
                            :disabled="selectedUser == null">Ajouter
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="updateDialog" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">Modification émetteur</span>
                </v-card-title>
                <v-card-text>
                    <v-container v-if="selectedSender !== null">
                        <v-text-field outlined label="Email" :disabled="true" :value="selectedSender.emailable.email">
                        </v-text-field>
                        <v-text-field label="Nom" outlined v-model="selectedSender.name">

                            <v-tooltip slot="append" bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="on">help</v-icon>
                                </template>
                                <span>Nom d'expéditeur utilisé pour l'envoi des mails</span>
                            </v-tooltip>

                        </v-text-field>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red" style="color: white" @click="closeUpdateDialog">Annuler</v-btn>
                    <v-btn class="default-button" @click="updateSender">Enregistrer</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <confirm ref="confirm"></confirm>
    </div>
</template>

<script>
import Confirm from "../../tools/Confirm"
import { mapState } from "vuex"

export default {
    name: "Sender",
    props: ['singleMod'],
    components: { Confirm },
    data() {
        return {
            selectMemberDialog: false,
            selectedUser: null,
            outboxEmail: null,
            senderName: null,
            selectedSender: null,
            updateDialog: false,
            headers: [
                {
                    text: 'Nom',
                    value: 'name'
                },
                {
                    text: 'Email',
                    value: 'emailable.email'
                },
                {
                    text: "Validé pour l'envoi",
                    value: 'state_label'
                },
                {
                    text: '',
                    value: 'actions'
                },
            ],
        }
    },
    methods: {
        goNextStep() {
            this.$global.$emit('change-step', 4)
        },
        selectSender() {
            if (typeof this.selectedUser === "object") {
                this.associateSender()
            } else {
                this.createOutbox()
            }
        },
        async associateSender() {
            let payload = {
                userId: this.selectedUser.id,
                name: this.senderName
            }

            this.$global.loading = true

            await this.$http.post('auth/onboarding/steps/sender/select', payload)
            await this.$store.dispatch('account/loadSenders', false)
            await this.$store.dispatch('account/getCredentials')

            this.selectMemberDialog = false
            this.$global.loading = false
        },
        async createOutbox() {
            let payload = {
                email: this.selectedUser,
                name: this.senderName
            }

            this.$global.loading = true

            await this.$http.post('auth/onboarding/steps/sender/create', payload)
            await this.$store.dispatch('account/loadSenders', false)
            await this.$store.dispatch('account/getCredentials')

            this.outboxEmail = null

            this.selectMemberDialog = false
            this.$global.loading = false

        },
        async checkEmailsValidation() {
            let btn = document.getElementById('updateBtn')

            btn.classList.add('fa-spin')

            await this.$http.get('auth/onboarding/steps/sender/check')
            await this.$store.dispatch('account/loadSenders', false)
            await this.$store.dispatch('account/getCredentials')

            this.$global.$emit('saved-config-no-loader')

            btn.classList.remove('fa-spin')
        },
        prepareUpdate(sender) {
            this.selectedSender = JSON.parse(JSON.stringify(sender))
            this.updateDialog = true
        },
        closeUpdateDialog() {
            this.selectedSender = null
            this.updateDialog = false
        },
        async updateSender() {
            let payload = {
                senderId: this.selectedSender.id,
                name: this.selectedSender.name
            }

            this.$global.loading = true

            await this.$http.post('auth/onboarding/steps/sender/update', payload)
            await this.$store.dispatch('account/loadSenders', false)
            await this.$store.dispatch('account/getCredentials')

            this.$global.loading = false

            this.updateDialog = false
        },
        deleteSender(sender) {
            this.$refs.confirm.open('Suppression d\'une boîte d\'envoi',
                'Êtes-vous sûr de vouloir supprimer la boîte d\'envoi ' +
                sender.emailable.email + ' ?',
                { color: 'red' }).
                then(async (confirm) => {
                    if (confirm) {
                        this.$global.loading = true

                        await this.$http.delete('auth/onboarding/steps/sender/' + sender.id)
                        await this.$store.dispatch('account/loadSenders', false)
                        await this.$store.dispatch('account/getCredentials')

                        this.$global.loading = false
                    }
                })
        },
        async sendEmailVerif(sender) {
            let payload = {
                sender: sender
            }

            this.$global.loading = true

            await this.$http.post('auth/onboarding/steps/sender/resend', payload)
            await this.$store.dispatch('account/loadSenders', false)
            await this.$store.dispatch('account/getCredentials')

            this.$global.loading = false
        }
    },
    computed: {
        ...mapState('account', ['account']),
        availableSenders() {
            let senders = []

            this.account.users.forEach(user => {
                let existSender = this.account.senders.find(sender => sender.emailable.email === user.email)

                if (existSender === undefined) {
                    senders.push(user)
                }
            })

            return senders
        }
    },
    watch: {
        selectMemberDialog() {
            if (this.selectMemberDialog) {
                this.selectedUser = null
                this.senderName = null
            }
        },
        selectedUser() {
            if (this.selectedUser !== null && typeof this.selectedUser === "object") {
                this.senderName = this.selectedUser.first_name + ' ' + this.selectedUser.last_name
            }
        }
    }
}
</script>
